import { VipSettings } from "./type"

export const DEFAULT_VIP_RAKEBACK: VipSettings = {
  tiers: [
    {
      id: "base",
      name: "Base",
      minTotalWagerUsd: 0,
      rakebackPercent: 5,
      // No VIP weekly/monthly bonus for base
      weeklyWagerRate: 0,
      monthlyWagerRate: 0,
      lossbackRate: 0
    },
    {
      id: "bronze",
      name: "Bronze",
      minTotalWagerUsd: 10_000,
      rakebackPercent: 5,
      // W × 0.0005, W × 0.002
      weeklyWagerRate: 0.0005,
      monthlyWagerRate: 0.002,
      lossbackRate: 0 // no lossback in formula
    },
    {
      id: "silver",
      name: "Silver",
      minTotalWagerUsd: 50_000,
      rakebackPercent: 6,
      // W × 0.0008, W × 0.0025
      weeklyWagerRate: 0.0008,
      monthlyWagerRate: 0.0025,
      lossbackRate: 0 // no lossback in formula
    },
    {
      id: "gold",
      name: "Gold",
      minTotalWagerUsd: 100_000,
      rakebackPercent: 7,
      // (W × 0.001) + (L × 0.080/4), (W × 0.003) + (L × 0.080)
      weeklyWagerRate: 0.001,
      monthlyWagerRate: 0.003,
      lossbackRate: 0.08
    },

    // PLATINUM
    {
      id: "platinum-1",
      name: "Platinum I",
      minTotalWagerUsd: 250_000,
      rakebackPercent: 8,
      // (W × 0.0012) + (L × 0.088/4), (W × 0.0035) + (L × 0.088)
      weeklyWagerRate: 0.0012,
      monthlyWagerRate: 0.0035,
      lossbackRate: 0.088
    },
    {
      id: "platinum-2",
      name: "Platinum II",
      minTotalWagerUsd: 500_000,
      rakebackPercent: 8.5,
      // (W × 0.0014) + (L × 0.096/4), (W × 0.004) + (L × 0.096)
      weeklyWagerRate: 0.0014,
      monthlyWagerRate: 0.004,
      lossbackRate: 0.096
    },
    {
      id: "platinum-3",
      name: "Platinum III",
      minTotalWagerUsd: 1_000_000,
      rakebackPercent: 9,
      // (W × 0.0016) + (L × 0.104/4), (W × 0.0045) + (L × 0.104)
      weeklyWagerRate: 0.0016,
      monthlyWagerRate: 0.0045,
      lossbackRate: 0.104
    },

    // EMERALD
    {
      id: "emerald-1",
      name: "Emerald I",
      minTotalWagerUsd: 2_500_000,
      rakebackPercent: 10,
      // (W × 0.0018) + (L × 0.112/4), (W × 0.005) + (L × 0.112)
      weeklyWagerRate: 0.0018,
      monthlyWagerRate: 0.005,
      lossbackRate: 0.112
    },
    {
      id: "emerald-2",
      name: "Emerald II",
      minTotalWagerUsd: 5_000_000,
      rakebackPercent: 11,
      // (W × 0.002) + (L × 0.120/4), (W × 0.0055) + (L × 0.120)
      weeklyWagerRate: 0.002,
      monthlyWagerRate: 0.0055,
      lossbackRate: 0.12
    },
    {
      id: "emerald-3",
      name: "Emerald III",
      minTotalWagerUsd: 10_000_000,
      rakebackPercent: 12,
      // (W × 0.0021) + (L × 0.120/4), (W × 0.0057) + (L × 0.120)
      weeklyWagerRate: 0.0021,
      monthlyWagerRate: 0.0057,
      lossbackRate: 0.12
    },

    // DIAMOND
    {
      id: "diamond-1",
      name: "Diamond I",
      minTotalWagerUsd: 25_000_000,
      rakebackPercent: 13,
      // (W × 0.0022) + (L × 0.120/4), (W × 0.006) + (L × 0.120)
      weeklyWagerRate: 0.0022,
      monthlyWagerRate: 0.006,
      lossbackRate: 0.12
    },
    {
      id: "diamond-2",
      name: "Diamond II",
      minTotalWagerUsd: 50_000_000,
      rakebackPercent: 13.5,
      // (W × 0.0023) + (L × 0.120/4), (W × 0.0062) + (L × 0.120)
      weeklyWagerRate: 0.0023,
      monthlyWagerRate: 0.0062,
      lossbackRate: 0.12
    },
    {
      id: "diamond-3",
      name: "Diamond III",
      minTotalWagerUsd: 100_000_000,
      rakebackPercent: 14,
      // (W × 0.0024) + (L × 0.120/4), (W × 0.0064) + (L × 0.120)
      weeklyWagerRate: 0.0024,
      monthlyWagerRate: 0.0064,
      lossbackRate: 0.12
    },

    // BLOOD DIAMOND
    {
      id: "blood-diamond-1",
      name: "Blood Diamond I",
      minTotalWagerUsd: 500_000_000,
      rakebackPercent: 14.5,
      // (W × 0.0025) + (L × 0.120/4), (W × 0.0066) + (L × 0.120)
      weeklyWagerRate: 0.0025,
      monthlyWagerRate: 0.0066,
      lossbackRate: 0.12
    },
    {
      id: "blood-diamond-2",
      name: "Blood Diamond II",
      minTotalWagerUsd: 1_000_000_000,
      rakebackPercent: 15,
      // (W × 0.0026) + (L × 0.120/4), (W × 0.0068) + (L × 0.120)
      weeklyWagerRate: 0.0026,
      monthlyWagerRate: 0.0068,
      lossbackRate: 0.12
    },

    // LEGEND
    {
      id: "legend",
      name: "Legend",
      minTotalWagerUsd: 0,
      rakebackPercent: 16,
      invitationOnly: true,
      // (W × 0.0028) + (L × 0.120/4), (W × 0.007) + (L × 0.120)
      weeklyWagerRate: 0.0028,
      monthlyWagerRate: 0.007,
      lossbackRate: 0.12
    }
  ]
}
